import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { insuranceRegisterList } from "../../../../../../../services/ticketAutomationReceivedRuleInsurance.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.appointmentArrival.";

export const Insurances = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(insuranceRegisterList);

  const [insurances, setInsurances] = useState<ISelectType[]>([]);

  const fetchRegisterList = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setInsurances(
        data.map((insurance) => ({
          id: insurance.identifier.toString(),
          name: insurance.insuranceName,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchRegisterList();
  }, [fetchRegisterList]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        name="insurances"
        options={insurances}
        label={t(translationPath + "insurances")}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
        keepOpenOnSelect
      />
    </Grid>
  );
});
